import React, { Component } from 'react';
import { connect } from 'react-redux';
import TaskPres from '../Presentation/TaskPres';
import { transformFormValues } from 'src/helpers';
import { completeTasks, saveGroupTask } from 'src/services/tasks.service.js';
import { withSnackbar } from 'notistack';
import { CASE_DATA_COLLECT_COMPOSE_URL, CASE_DATA_MENUTYPES } from 'src/constants/constants.js';
import { getActionRequiredProfileById, setShowProfileIconNameState } from '../../../../ui/features/Tasks/state/tasksActions';
import { setCaseSubmitted, setDocumentTaskStatusState } from '../../CaseDataCollect/state/caseDataCollectAction';
import { fetchEmployersLookupValues } from 'src/services/accounts.service';
import { fnGetMenuTypeCode } from 'src/helpers/commonFunctions';

class TaskContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      hostRows: null,
      additionalInfo: null,
      formValues: null,
      taskDetails: null,
      isCompleted: false,
      isCheckboxChecked: false,
      isLastReviewTask: false,
    };
  }

  componentDidMount() {
    const {
      match: {
        params: { pageId },
      },
    } = this.props;
    this.setState({ taskId: pageId, isLoading: true });
    fetchEmployersLookupValues({
      filter: true,
      sortDirection: 'asc',
      pageSize: 100,
      pageNumber: 1,
    }).then(response => {
      this.setState({ isLoading: false });
      if (response && response.rows) {
        const data = response.rows.map((row, index) => ({ ...row, index }));
        this.setState({ hostRows: data });
      }
    });
  }
  componentDidUpdate(prevState) {
    const {
      match: {
        params: { pageId },
      },
    } = this.props;
    if (this.state.isLastReviewTask && prevState && prevState.match.params.pageId !== pageId) {
      this.setState({ isLastReviewTask: false });
    }
  }

  componentWillUnmount() {
    this.props.setDocumentTaskStatusState(false);
  }

  setCompletedStatus = status => {
    this.setState({ isCompleted: status });
  };

  checkComplete = (e, v) => {
    this.props.setShowProfileIconNameState(true);
  };

  handleTabChange = async () => {
    this.setCompletedStatus(false);
  };

  getAdditionalInfoForCurrentTask = additionalInfo => {
    this.setState({
      additionalInfo: additionalInfo,
    });
  };

  updateCurrentTaskFormValues = formData => {
    this.setState({
      formValues: formData.formValues,
    });
  };

  setCheckboxChecked = flag => {
    this.setState({ isCheckboxChecked: flag });
  };

  saveCurrentTaskForm = async (caseId, pageId) => {
    const { formValues, additionalInfo } = this.state;
    if (!formValues) return;
    const payload = {
      ...transformFormValues(formValues),
      entityId: additionalInfo.referencingId || pageId,
      parentId: pageId,
      caseId: caseId,
      entityLogicalName: additionalInfo.referencingEntity,
    };

    this.setState({ isLoading: true });
    await saveGroupTask(payload).then(
      res => {
        // this.props.enqueueSnackbar('Successfully updated record.', {
        //   variant: 'success',
        // });
        this.setState({ isLoading: false });
      },
      error => {
        this.props.enqueueSnackbar('Error: ' + error.message, {
          variant: 'error',
        });
        this.setState({ isLoading: false });
      },
    );
  };

  gotoPage = () => {
    const {
      history,
      caseDatacollectMenu: { menuDetails },
      match: {
        params: { caseId, sectionId, pageId },
      },
    } = this.props;
    const taskMenuDetails =
      menuDetails && menuDetails.length > 0 ? menuDetails.filter(x => x.menuTypeCode === 2 || x.menuTypeCode === 3) : [];
    if (taskMenuDetails && taskMenuDetails.length > 0) {
      for (let i = 0; i < taskMenuDetails.length; i++) {
        const subMenu = taskMenuDetails[i].subMenu;
        const menuIndex = subMenu.findIndex(x => x.pageId === pageId);
        const count = subMenu.length - 1;
        if (menuIndex !== -1 && menuIndex <= count) {
          if (menuIndex !== count) {
            const newPageId = subMenu[menuIndex + 1].pageId;
            history.push(CASE_DATA_COLLECT_COMPOSE_URL + '/' + caseId + '/' + sectionId + '/' + newPageId);
          }
          if (taskMenuDetails[i].menuTypeCode === CASE_DATA_MENUTYPES.REVIEW && menuIndex === count) {
            this.setState({ isLastReviewTask: true });
          }
          break;
        }
      }
    }
  };

  handleSave = async () => {
    const {
      match: {
        params: { caseId, pageId },
      },
      setDocumentTaskStatusState,
    } = this.props;
    await this.saveCurrentTaskForm(caseId, pageId);
    this.setState({
      isLoading: true,
    });
    const completeTasksIds = [pageId];
    completeTasks(completeTasksIds, fnGetMenuTypeCode(this.props.caseDatacollectMenu), this.props.match.params.caseId).then(res => {
      this.setCompletedStatus(true);
      setDocumentTaskStatusState(true);
      this.setState({
        isLoading: false,
      });
      this.props.enqueueSnackbar('Completed tasks are submitted.', {
        variant: 'success',
      });
      this.props.setCaseSubmitted(true);
      this.gotoPage();
    });
  };

  render() {
    if (this.state.isLastReviewTask) {
      return;
    }
    return (
      <div className="case-data-task-container">
        <TaskPres
          checkComplete={this.checkComplete}
          handleTabChange={this.handleTabChange}
          handleSave={this.handleSave}
          setCompletedStatus={this.setCompletedStatus}
          saveCurrentTaskForm={this.saveCurrentTaskForm}
          updateCurrentTaskFormValues={this.updateCurrentTaskFormValues}
          getAdditionalInfoForCurrentTask={this.getAdditionalInfoForCurrentTask}
          setCheckboxChecked={this.setCheckboxChecked}
          caseHeaderDetails={this.props.casedetails}
          {...this.props}
          {...this.state}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    userInfo: state.login.userInfo,
    caseDatacollectMenu: state.caseDatacollectMenu,
    casedetails: state.caseDatacollectMenu.caseHeaderDetails,
  };
};

const mapDispatchToProps = {
  getActionRequiredProfileById,
  setShowProfileIconNameState,
  setCaseSubmitted,
  setDocumentTaskStatusState,
};

export default connect(mapStateToProps, mapDispatchToProps)(withSnackbar(TaskContainer));
